import type { PlatformDataResponse, Release } from "api/dashboardBackend";
import styles from "components/dashboard/Dashboard.module.scss";
import ReadinessStatus from "components/dashboard/release-card/ReadinessStatus";
import ReleaseStatus from "components/dashboard/release-card/ReleaseStatus";

interface Props {
  release: Release;
  platformData: PlatformDataResponse;
}

const ReleaseCardHeader = ({ release, platformData }: Props) => (
  <div className={styles.status}>
    <ReleaseStatus platformData={platformData} release={release} />
    <ReadinessStatus platformData={platformData} release={release} />
  </div>
);

export default ReleaseCardHeader;
